import { generateLabelsAndValues, generateTypeOfCPDLabelsAndValues } from "../utils/HelperFunctions";
import { CERTIFICATE_TYPE } from "./NewApplicantsConstants";

export const CPD_SUBMISSION_STATUS_CONSTANT = {
    PENDING: 1,
    SUBMITTED: 2,
    APPROVED: 3,
    REJECTED: 4,
    KIV: 5,
    ALL: 6,
    INCOMPLETE_DOCUMENT: 7,
};
export const CPD_SUBMISSION_STATUS_TAB = [
    {
        name: "ALL",
        type: CPD_SUBMISSION_STATUS_CONSTANT.ALL,
    },
    {
        name: "Pending",
        type: CPD_SUBMISSION_STATUS_CONSTANT.PENDING,
    },
    {
        name: "Submitted",
        type: CPD_SUBMISSION_STATUS_CONSTANT.SUBMITTED,
    },
    {
        name: "Approved",
        type: CPD_SUBMISSION_STATUS_CONSTANT.APPROVED,
    },
    {
        name: "KIV",
        type: CPD_SUBMISSION_STATUS_CONSTANT.KIV,
    },
    {
        name: "Rejected",
        type: CPD_SUBMISSION_STATUS_CONSTANT.REJECTED,
    },
    // {
    //     name: "Incomplete Documents",
    //     type: CPD_SUBMISSION_STATUS_CONSTANT.INCOMPLETE_DOCUMENT,
    // },
];

export const CPD_CERTIFICATE_TYPE = [
    {
        name: "Professional Technologist",
        type: CERTIFICATE_TYPE.PROFESSIONAL_TECHNOLOGIST,
    },
    {
        name: "Certified Technician",
        type: CERTIFICATE_TYPE.CERTIFIED_TECHNICIAN,
    },
];

export const MEMBERSHIP_CERTIFICATE_TYPE = [
    {
        name: "ALL",
        type: CERTIFICATE_TYPE.ALL_AVAILABLE,
    },
    {
        name: "Graduate Technologist",
        type: CERTIFICATE_TYPE.GRADUATE_TECHNOLOGIST,
    },
    {
        name: " Qualified Technician",
        type: CERTIFICATE_TYPE.QUALIFIED_TECHNICIAN,
    },
    {
        name: "Professional Technologist",
        type: CERTIFICATE_TYPE.PROFESSIONAL_TECHNOLOGIST,
    },
    {
        name: "Certified Technician",
        type: CERTIFICATE_TYPE.CERTIFIED_TECHNICIAN,
    },
];

export const TypeOfCPD = {
    FORMAL_EDUCATION: 1,
    INFORMAL_EDUCATION: 2,
    CONGRESS_CONFERENCE_SEMINAR_SYMPOSIUM: 3,
    FELLOWSHIPS_ATTACHMENT_STUDY_TOUR: 4,
    COMMITTEE_PROJECT_MEMBER: 5,
    TECHNOLOGY_AND_TECHNICAL_RELATED_MEETING: 6,
    TECHNICAL_PAPER_PRESENTATION_AT_OFFICAL_FUNCTION_SEMINAR_MEETINGS: 7,
    PUBLICATION_OF_ARTICLES_IN_JOURNAL_CHAPTERS_IN_BOOK_TECHNICAL_REPORTS: 8,
    APPOINTED_AS_MBOT: 9,
    PROFESSIONAL_ASSESSOR_PANEL: 10,
    ACCREDITATION_ASSESSOR_PANEL: 11,
    ACCREDITATION_VISITS: 12,
    CONTRIBUTION_FOR_TECHNOLOGY_AND_TECHNICAL_ASPECTS_DEVELOPMENT: 13,
    ONLINE_PLATFORM_RELATED_TO_TECHNOLOGY_AND_TECHNICAL: 14,
    MENTORING_COACHING_JUDGES_CONSULTATION_RELATED_TO_PROFESSION: 15,
    HANDS_ON_SPECIAL_PROJECT_AND_RND_ACTIVITIES_RELATED_IN_TECHNOLOGY_AND_TECHNICAL: 16,
    CSR_PROGRAMME_AND_RELEVENT_VOLUNTARY_WORK: 17,
    SOFT_SKILLS_RELATED_TO_LEADERSHIP_AND_MANAGEMENT_INTERPERSONAL_SKILLS_AND_PROFESSIONAL_CONDUCT: 18,
};

export const UserCPDStatus = {
    PENDING: 1,
    SUBMITTED: 2,
    APPROVED: 3,
    REJECTED: 4,
    KIV: 5,
    ALL: 6,
    INCOMPLETE: 7,
};

export const findTypeOfCpd = (type) => {
    const data = TypeOfCPDActivities?.find((cpd) => cpd?.value === type);
    return data?.label;
};

export const TypeOfCPDActivities = generateTypeOfCPDLabelsAndValues(TypeOfCPD);
export const TypeOfUserCPDStatus = generateLabelsAndValues(UserCPDStatus);

export const CPDActivityInitialValues = {
    title: "",
    location: "",
    duration_time: "",
    start_date_time: null,
    end_date_time: null,
    tech_field: [],
    files: [],
    type_of_cpd: "",
    web_url: "",
    description: "",
    duration_type: 2,
    target_audience: "",
    attachment: [],
    cpd_date: null,
    copy_of_programme_kit: "",
    sample_of_poster: "",
    sample_of_certificate: "",
    trainer_profile: "",
    documentary_evidence: "",
    other_relevant_documentation: "",
    reason: "",
};

export const TypeOfAudience = {
    PROFESSIONAL_TECHNOLOGISTS: 1,
    CERTIFIED_TECHNICIANS: 2,
    OPEN_FOR_ALL: 3,
    GENERAL_AUDIENCE: 4,
};

export const TypeOfCPDTaregetAudience = generateLabelsAndValues(TypeOfAudience);

// Type of duration start
export const durationType = {
    HOURS: 1,
    DAYS: 2,
};

export const DurationType = generateLabelsAndValues(durationType);
